<template>
  <div class="modal-content border-0 shadow">
    <div class="modal-body">
      <div class="col-12 col-md-9 mx-auto">
        <div class="d-flex mx-auto">
          <img
            :src="`${aws}/unicorn-feather.png`"
            class="mx-auto mb-3"
          >
        </div>
        <h5 class="text-center">
          Dernière étape pour finaliser votre inscription !
        </h5>
        <p class="text-center text-md-start">
          Définissez ici votre mot de passe pour accéder à votre espace de gestion
        </p>
        <form class="form-create">
          <div class="form-label-group mb-3">
            <label
              class="form-label"
              for="inputPassword"
            >
              Nouveau mot de passe
            </label>
            <div class="input-group">
              <input
                id="inputPassword"
                v-model="password"
                :type="selected? 'text':'password'"
                class="form-control"
                autocomplete="current-password"
                placeholder=""
                required
              >
              <div
                class="cursor-pointer input-group-text bg-white border-start-0"
                @click="selected = !selected"
              >
                <v-icon
                  :icon="selected ? 'eye-blue-500': 'eye-hidden-blue-500'"
                  height="19"
                  width="19"
                />
              </div>
            </div>
          </div>
          <div class="form-label-group mb-3">
            <label
              class="form-label"
              for="inputconfirmPassword"
            >
              Confirmation du nouveau mot de passe
            </label>
            <div class="input-group">
              <input
                id="inputconfirmPassword"
                v-model="confirmPassword"
                :type="selectedConfirm? 'text':'password'"
                class="form-control"
                autocomplete="current-password"
                placeholder=""
                required
              >
              <div
                class="cursor-pointer input-group-text bg-white border-start-0"
                @click="selectedConfirm = !selectedConfirm"
              >
                <v-icon
                  :icon="selectedConfirm ? 'eye-blue-500': 'eye-hidden-blue-500'"
                  height="19"
                  width="19"
                />
              </div>
            </div>
          </div>
          <transition
            @enter="tf_slideDown"
            @leave="tf_slideUp"
          >
            <div
              v-if="error"
              class="invalid-feedback mb-3"
            >
              {{ error }}
            </div>
          </transition>
          <div class="col-12 mb-3">
            <div class="row">
              <div
                v-for="validator in validators"
                :key="validator.id"
                class="col-12 col-md-6 flex-row d-flex fs-14 text-gray-600 mb-1"
              >
                <font-awesome-icon
                  :icon="validator.isValid ? ['fas', 'check']: ['fas', 'circle']"
                  class="d-flex me-1 my-auto"
                  :class="validatorColor(validator.isValid)"
                  style="width:8px; height: 8px"
                />
                <div :class="validatorColor(validator.isValid)">
                  {{ validator.message }}
                </div>
              </div>
            </div>
          </div>
          <v-loader
            :next="definePassword"
            :disable-button="(!isPasswordValid || password !== confirmPassword)"
            title="Définir mon mot de passe"
            icon="arrow-white-right"
            class="w-100 mb-3"
          />
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { validatePassword } from '@/utils/validators';
import { transform, ui } from '@/mixins';

export default {
  mixins: [transform, ui],
  data() {
    return {
      password: '',
      confirmPassword: '',
      selected: false,
      selectedConfirm: false,
      error: null,
    };
  },
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
    validators() {
      return validatePassword(this.password, this.confirmPassword);
    },
    isPasswordValid() {
      return !(this.validators.some(({ isValid }) => !isValid));
    },
  },
  methods: {
    validatorColor(value) {
      if (value === null) return 'text-gray-500';
      return value ? 'text-green-700' : 'text-red-500';
    },
    async definePassword() {
      try {
        await this.$store.dispatch('client/updatePassword', {
          password: this.password,
          confirmPassword: this.confirmPassword,
        });
        this.ui_showModal(false);
        this.ui_showFeedbackModal(true);
      } catch (err) {
        this.error = 'Le mot de passe renseigné ne répond pas à tous les critères de sécurité';
      }
    },
  },
};
</script>
